import {Grid, makeStyles} from "@material-ui/core";
import React, {FC} from "react";
import {useParams} from "react-router-dom";
import {PersonHeadline} from "../../../sharedComponents/PersonHeadline";
import {useAdmin} from "../redux/admins.hook";
import {AdminProfileCard} from "./AdminProfileCard";
import {AdminStatusDialog} from "../form/AdminStatusDialog";

const useStyles = makeStyles((theme) => ({
    statusButton: {
        marginTop: theme.spacing(6)
    },
    card: {
        height: "100%"
    }
}))

export const AdminScreen: FC = () => {
    const classes = useStyles();
    const {id} = useParams<{ id: string }>();
    const {admin} = useAdmin(id);

    return (
        <React.Fragment>
            <PersonHeadline person={admin}/>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <AdminProfileCard
                        admin={admin}
                        cardProps={{className: classes.card}}
                    />
                </Grid>
            </Grid>
            {admin && (
                <AdminStatusDialog
                    adminId={admin.id}
                    adminName={`${admin.firstName} ${admin.lastName}`}
                    active={admin.active}
                    className={classes.statusButton}
                />
            )}
        </React.Fragment>
    )
}